import { createContext } from 'react';
import { NotificationProps } from '../components/ui/Notification';

interface NotificationContextType {
  notify: (props: Omit<NotificationProps, 'id' | 'onClose'>) => void;
  success: (message: string, title?: string) => void;
  error: (message: string, title?: string) => void;
  warning: (message: string, title?: string) => void;
  info: (message: string, title?: string) => void;
  clearAll: () => void;
}

export const NotificationContext = createContext<NotificationContextType | undefined>(undefined);
